module.exports = __webpack_public_path__ + "img/T1A_xh_11.0efd6fe2.png";